import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

function SEO({
  description,
  lang,
  meta,
  title,
  image,
  canonical,
  url,
  breadcrumbs,
}) {
  const { wp, site } = useStaticQuery(graphql`
    query {
      wp {
        allSettings {
          generalSettingsTitle
          generalSettingsDescription
        }
        crbThemeOptions {
          crbLogoHeader {
            media {
              publicUrl
            }
          }
        }
      }
      site {
        siteMetadata {
          author
          siteUrl
        }
      }
    }
  `);

  const metaDescription =
    description || wp.allSettings.generalSettingsDescription;

  return (
    <>
      <html lang={lang} />
      <title>{title}</title>
      {canonical && (
        <link rel="canonical" href={site.siteMetadata.siteUrl + canonical} />
      )}
      <meta name="description" content={metaDescription} />
      <meta
        name="google-site-verification"
        content={process.env.GATSBY_GOOGLE_SITE_VERIFICATION}
      />
      <meta property="og:title" content={title} />
      <meta
        property="og:image"
        content={
          image ||
          `${site.siteMetadata.siteUrl}${wp.crbThemeOptions?.crbLogoHeader?.media?.publicUrl}`
        }
      />
      <meta
        property="og:url"
        content={
          canonical
            ? site.siteMetadata.siteUrl + canonical
            : site.siteMetadata.siteUrl + url
        }
      />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      {meta.map(({ name, content }) => (
        <meta name={name} content={content} key={name} />
      ))}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: breadcrumbs.map((item, index) => ({
            "@type": "listItem",
            position: index + 1,
            name: item.text,
            item: process.env.GATSBY_SITE_URL + item.url,
          })),
        })}
      </script>
    </>
  );
}

SEO.defaultProps = {
  lang: `no`,
  meta: [],
  description: ``,
  image: ``,
  canonical: ``,
  url: ``,
  breadcrumbs: [],
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  canonical: PropTypes.string,
  url: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.object),
};

export default SEO;
